import * as _ from 'lodash'
import {TPMPlanBO} from "../PA.TPM.BusinessObjects/TPMPlanBO";
import {PlanningService} from "./PlanningService"
import {NumberUtils} from "../PA.Core/Basic/Numbers";
// async-lock


export class TPMPlanStandardCalculatorUtils {

   static applyBaseline(aTPMPlanBO: TPMPlanBO, request: {[Field_Name: string]: {wb_baseln_id: number}}, pWB_PrdGrp_IDs?: number[]): Promise<void> {

     return new Promise<void>((resolve, error) => {

       if(_.isEmpty(request)){
         resolve()
        return
       }

       let bProductGroupsOnly = false
       let arrWB_PrdGrp_IDs: number[] = []

       if(!_.isEmpty(pWB_PrdGrp_IDs)){
         arrWB_PrdGrp_IDs = pWB_PrdGrp_IDs
         bProductGroupsOnly = true
       } else {
         arrWB_PrdGrp_IDs = _.map(aTPMPlanBO.ProductGroups, (aPG) => aPG.cif.WB_PRDGRP_ID)
       }

       let arrWB_Period_IDs = _.map(aTPMPlanBO.PlannedPeriods, (aPrd) => aPrd.cif.WB_PERIOD_ID)
       let arrWB_Baseln_IDs: number[] =  _.map(request, (value) => value.wb_baseln_id)

       if(_.isEmpty(arrWB_PrdGrp_IDs) || _.isEmpty(arrWB_Period_IDs) || _.isEmpty(arrWB_Baseln_IDs)){
         resolve()
         return
       }

       // Remove Zeros
       arrWB_Baseln_IDs  = _.filter( arrWB_Baseln_IDs, (a) => (a > 0))
       let aPlanningService = new PlanningService()
       aPlanningService.getBaselineData({arrWB_BASELINE_IDs: arrWB_Baseln_IDs, UOM: aTPMPlanBO.WB_Plan.WB_PlanTypeRow.cif.QUANTITY_UOM, arrWB_PRDGRP_IDs: arrWB_PrdGrp_IDs, arrWB_PERIOD_IDs: arrWB_Period_IDs})
         .then((results) => {

           // Apply the Baselines
           _.forEach(request, (value, key) => {
             let targetFieldName = key
             let wb_baseln_id: number =  value.wb_baseln_id
             let baselineData = (results[wb_baseln_id]) || {dctPrdGrpId:{}}

             if(_.isEmpty(targetFieldName)){ return }

             let dctPrdGrps = _.keyBy(arrWB_PrdGrp_IDs, (a)=> a)
             let arrPlanPrdGrpVolumes = bProductGroupsOnly? _.filter(aTPMPlanBO.PlanVolumeMetrics, (aRow) => (aRow.cif.WB_PRDGRP_ID in dctPrdGrps)) : aTPMPlanBO.PlanVolumeMetrics

             _.forEach(arrPlanPrdGrpVolumes, (aRow) => {
                //
               let aValue = 0
               let aPG = baselineData.dctPrdGrpId[aRow.cif.WB_PRDGRP_ID]
               if(aPG){
                 aValue = NumberUtils.round( + (aPG.dctPeriodId[aRow.cif.WB_PERIOD_ID]) || 0,6)
               }
               // @ts-ignore
               aRow[targetFieldName] = aValue
             })
           })
            resolve()
         })
         .catch((err) => {
           error(err)
         })

     })
   }

}